import { useQuery } from '@tanstack/react-query'
import {
  fetchSubInterfaces,
  subsQueryKey,
  SubInterface,
} from './resolveSourceInterfaceIds'

/**
 * The controllers hanging off a control hub, or an empty list for a plain
 * controller.
 *
 * Each sub-controller is an interface in its own right — the same id every
 * decoder, station and import endpoint takes — so anything that has to act on
 * one addresses it by `interfaceId` rather than through the hub.
 *
 * Shares the `subs` cache entry with `useIsControlHub` and
 * `resolveSourceInterfaceIds`, so the list is fetched once per page.
 */
const useSubControllers = (interfaceId: number) =>
  useQuery<SubInterface[]>(subsQueryKey(interfaceId), () => fetchSubInterfaces(interfaceId), {
    enabled: interfaceId > 0,
    staleTime: 5 * 60 * 1000,
    placeholderData: [],
  })

/** What the user calls a sub-controller, with sensible fallbacks. */
export const subControllerLabel = (sub: SubInterface) =>
  sub.customName?.trim() ||
  sub.name?.trim() ||
  (sub.twiId ? `Controller ${sub.twiId}` : `Interface ${sub.interfaceId}`)

export default useSubControllers
